import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main className="content old-theme" style={{ paddingTop: "70px" }}>
        <div className="container page page--no-sidebar">
          <div className="page__content">
            <div className="rte">
              <div id="iub-pp-container">
                <div className="iubenda_legal_document">
                  <h1>
                    Privacy Policy of <strong>www.bernicemy.blog</strong>
                  </h1>
                  <p>
                    Www.bernicemy.blog collects some Personal Data from its
                    Users.
                  </p>
                  <br />
                  <p>
                    Users may be subject to different protection standards and
                    broader standards may therefore apply to some. Users can
                    contact the Owner, to learn more about such standards.
                  </p>
                  <br />
                  <p>
                    This document can be printed for reference by using the
                    print command in the settings of any browser.
                  </p>
                  <h2 id="owner_of_the_data">Owner and Data Controller</h2>
                  {/* Owner start */}
                  <p>
                    Bernicemy Inc
                    <br />
                    114 N Court St
                    <br />
                    Florence, AL 35630
                  </p>
                  <p>
                    <strong>Owner contact email:</strong> shop@bernicemy.blog
                  </p>
                  {/* Owner end */}
                  <h2 id="types_of_data">Types of Data collected</h2>
                  <p>
                    Among the types of Personal Data that www.bernicemy.blog
                    collects, by itself or through third parties, there are:
                    Trackers; Usage Data; number of Users; session statistics;
                    unique device identifiers for advertising (Google Advertiser
                    ID or IDFA, for example); email address; purchase history;
                    payment info; device information; answers to questions;
                    clicks; keypress events; motion sensor events; mouse
                    movements; scroll position; touch events; phone number;
                    session duration; interaction events; page views.
                  </p>
                  <p>
                    Complete details on each type of Personal Data collected are
                    provided in the dedicated sections of this privacy policy or
                    by specific explanation texts displayed prior to the Data
                    collection.
                    <br />
                    Personal Data may be freely provided by the User, or, in
                    case of Usage Data, collected automatically when using
                    www.bernicemy.blog.
                    <br />
                    Unless specified otherwise, all Data requested by
                    www.bernicemy.blog is mandatory and failure to provide this
                    Data may make it impossible for www.bernicemy.blog to
                    provide its services. In cases where www.bernicemy.blog
                    specifically states that some Data is not mandatory, Users
                    are free not to communicate this Data without consequences
                    to the availability or the functioning of the Service.
                    <br />
                    Users who are uncertain about which Personal Data is
                    mandatory are welcome to contact the Owner.
                    <br />
                    Any use of Cookies – or of other tracking tools — by
                    www.bernicemy.blog or by the owners of third-party services
                    used by www.bernicemy.blog serves the purpose of providing
                    the Service required by the User, in addition to any other
                    purposes described in the present document and in the Cookie
                    Policy.
                  </p>
                  <p>
                    Users are responsible for any third-party Personal Data
                    obtained, published or shared through www.bernicemy.blog.
                  </p>
                  <h2 id="place_of_processing">
                    Mode and place of processing the Data
                  </h2>
                  <h3 className="iub-subheading iub-subheading-legal-mode-processing">
                    Methods of processing
                  </h3>
                  <p>
                    The Owner takes appropriate security measures to prevent
                    unauthorized access, disclosure, modification, or
                    unauthorized destruction of the Data.
                    <br />
                    The Data processing is carried out using computers and/or IT
                    enabled tools, following organizational procedures and modes
                    strictly related to the purposes indicated. In addition to
                    the Owner, in some cases, the Data may be accessible to
                    certain types of persons in charge, involved with the
                    operation of www.bernicemy.blog (administration, sales,
                    marketing, legal, system administration) or external parties
                    (such as third-party technical service providers, mail
                    carriers, hosting providers, IT companies, communications
                    agencies) appointed, if necessary, as Data Processors by the
                    Owner. The updated list of these parties may be requested
                    from the Owner at any time.
                  </p>
                  <h3 className="iub-subheading iub-subheading-legal-place">
                    Place
                  </h3>
                  <p>
                    The Data is processed at the Owner's operating offices and
                    in any other places where the parties involved in the
                    processing are located.
                    <br />
                    <br />
                    Depending on the User's location, data transfers may involve
                    transferring the User's Data to a country other than their
                    own. To find out more about the place of processing of such
                    transferred Data, Users can check the section containing
                    details about the processing of Personal Data.
                  </p>
                  <h3 className="iub-subheading iub-subheading-legal-time">
                    Retention time
                  </h3>
                  <p>
                    Unless specified otherwise in this document, Personal Data
                    shall be processed and stored for as long as required by the
                    purpose they have been collected for and may be retained for
                    longer due to applicable legal obligation or based on the
                    Users’ consent.
                  </p>
                  <h2 id="use_collected_data">The purposes of processing</h2>
                  <p>
                    The Data concerning the User is collected to allow the Owner
                    to provide its Service, comply with its legal obligations,
                    respond to enforcement requests, protect its rights and
                    interests (or those of its Users or third parties), detect
                    any malicious or fraudulent activity, as well as the
                    following: Analytics, Advertising, Tag Management, Managing
                    contacts and sending messages, Handling payments, Platform
                    services and hosting, Remarketing and behavioral targeting,
                    Displaying content from external platforms, Spam and bots
                    protection, Hosting and backend infrastructure, Traffic
                    optimization and distribution, Commercial affiliation and
                    Heat mapping and session recording.
                  </p>
                  <p>
                    For specific information about the Personal Data used for
                    each purpose, the User may refer to the section “Detailed
                    information on the processing of Personal Data”.
                  </p>
                  <div data-locale="en" />
                  <h2 id="data_processing_detailed_info">
                    Detailed information on the processing of Personal Data
                  </h2>
                  <p>
                    Personal Data is collected for the following purposes and
                    using the following services:
                  </p>
                  <h3 className="iub-purpose iub-purpose-12998819">
                    Advertising
                  </h3>
                  <p>
                    This type of service allows User Data to be utilized for
                    advertising communication purposes. These communications are
                    displayed in the form of banners and other advertisements on
                    www.bernicemy.blog, possibly based on User interests. This
                    does not mean that all Personal Data are used for this
                    purpose. Information and conditions of use are shown below.
                    Some of the services listed below may use Trackers to
                    identify Users or they may use the behavioral retargeting
                    technique, i.e. displaying ads tailored to the User’s
                    interests and behavior, including those detected outside
                    www.bernicemy.blog. For more information, please check the
                    privacy policies of the relevant services. Services of this
                    kind usually allow Users to opt out of such tracking. Users
                    may learn how to opt out of interest-based advertising more
                    generally by visiting the relevant opt-out section in this
                    document.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11132973">
                    Criteo (Criteo SA)
                  </h4>
                  <p>Criteo is an advertising service provided by Criteo SA.</p>
                  <p>
                    As part of the operation of www.bernicemy.blog, the Owner
                    and Criteo SA are joint controllers for the Criteo
                    advertising service.
                  </p>
                  <p>
                    For this purpose, the Owner has entered into a Data
                    Processing Agreement (DPA) with Criteo SA which can be
                    reviewed{" "}
                    <Link onClick={toTop} to="/">
                      here
                    </Link>
                    .
                  </p>
                  <p>
                    Users may at any time{" "}
                    <strong>withdraw their consent</strong> to the processing of
                    their Personal Data by Criteo and{" "}
                    <strong>
                      opt out of personalized advertising by clicking the{" "}
                      <Link onClick={toTop} to="/">
                        “Disable Criteo services”
                      </Link>
                    </strong>{" "}
                    button in Criteo’s{" "}
                    <Link onClick={toTop} to="/">
                      privacy policy
                    </Link>
                    .
                  </p>
                  <p>Personal Data processed: Trackers; Usage Data.</p>
                  <p>
                    Place of processing: France –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>{" "}
                    –{" "}
                    <Link onClick={toTop} to="/">
                      Opt Out
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11132977">
                    Meta ads conversion tracking (Meta pixel) (Meta Platforms,
                    Inc.)
                  </h4>
                  <p>
                    Meta ads conversion tracking (Meta pixel) is an analytics
                    service provided by Meta Platforms, Inc. that connects data
                    from the Meta Audience Network with actions performed on
                    www.bernicemy.blog. The Meta pixel tracks conversions that
                    can be attributed to ads on Facebook, Instagram and Meta
                    Audience Network.
                  </p>
                  <p>Personal Data processed: Trackers; Usage Data.</p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>{" "}
                    –{" "}
                    <Link onClick={toTop} to="/">
                      Opt out
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11132978">
                    Microsoft Advertising (Microsoft Corporation)
                  </h4>
                  <p>
                    Microsoft Advertising is an advertising service provided by
                    Microsoft Corporation.
                  </p>
                  <p>Personal Data processed: Trackers; Usage Data.</p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>{" "}
                    –{" "}
                    <Link onClick={toTop} to="/">
                      Opt Out
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11132981">
                    TikTok conversion tracking (TikTok Inc.)
                  </h4>
                  <p>
                    TikTok conversion tracking is an analytics and behavioral
                    targeting service provided by TikTok Inc. that connects data
                    from the TikTok advertising network with actions performed
                    on www.bernicemy.blog. The TikTok pixel tracks conversions
                    that can be attributed to TikTok ads and enables to target
                    groups of Users on the base of their past use of
                    www.bernicemy.blog.
                  </p>
                  <p>Personal Data processed: Trackers.</p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-12998818">
                    Analytics
                  </h3>
                  <p>
                    The services contained in this section enable the Owner to
                    monitor and analyze web traffic and can be used to keep
                    track of User behavior.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11132972">
                    Google Analytics 4 (Google LLC)
                  </h4>
                  <p>
                    Google Analytics 4 is a web analysis service provided by
                    Google LLC (“Google”). Google utilizes the Data collected to
                    track and examine the use of www.bernicemy.blog, to prepare
                    reports on its activities and share them with other Google
                    services. Google may use the Data collected to contextualize
                    and personalize the ads of its own advertising network. In
                    Google Analytics 4, IP addresses are used at collection time
                    and then discarded before Data is logged in any data center
                    or server. Users can learn more by consulting{" "}
                    <Link onClick={toTop} to="/">
                      Google’s official documentation
                    </Link>
                    .
                  </p>
                  <p>
                    In order to understand Google's use of Data, consult their{" "}
                    <Link onClick={toTop} to="/">
                      partner policy
                    </Link>{" "}
                    and their{" "}
                    <Link onClick={toTop} to="/">
                      Business Data page
                    </Link>
                    .
                  </p>
                  <p>
                    Personal Data processed: number of Users; session
                    statistics; Trackers; Usage Data.
                  </p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>{" "}
                    –{" "}
                    <Link onClick={toTop} to="/">
                      Opt Out
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11132974">
                    Google Analytics Advertising Reporting Features (Google LLC)
                  </h4>
                  <p>
                    Google Analytics on www.bernicemy.blog has Advertising
                    Reporting Features activated, which collects additional
                    information from the DoubleClick cookie (web activity) and
                    from device advertising IDs (app activity). It allows the
                    Owner to analyze specific behavior and interests Data
                    (traffic Data and Users' ads interaction Data) and, if
                    enabled, demographic Data (information about the age and
                    gender).
                  </p>
                  <p>
                    Users can opt out of Google's use of cookies by visiting
                    Google's{" "}
                    <Link onClick={toTop} to="/">
                      Ads Settings
                    </Link>
                    .
                  </p>
                  <p>
                    In order to understand Google's use of Data, consult their{" "}
                    <Link onClick={toTop} to="/">
                      partner policy
                    </Link>{" "}
                    and their{" "}
                    <Link onClick={toTop} to="/">
                      Business Data page
                    </Link>
                    .
                  </p>
                  <p>
                    Personal Data processed: Trackers; unique device identifiers
                    for advertising (Google Advertiser ID or IDFA, for example);
                    various types of Data as specified in the privacy policy of
                    the service.
                  </p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>{" "}
                    –{" "}
                    <Link onClick={toTop} to="/">
                      Opt Out
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11437560">
                    Meta Events Manager (Meta Platforms, Inc.)
                  </h4>
                  <p>
                    Meta Events Manager is an analytics service provided by Meta
                    Platforms, Inc. By integrating the Meta pixel, Meta Events
                    Manager can give the Owner insights into the traffic and
                    interactions on www.bernicemy.blog.
                  </p>
                  <p>Personal Data processed: clicks; page views.</p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>{" "}
                    –{" "}
                    <Link onClick={toTop} to="/">
                      Opt out
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-13312065">
                    Commercial affiliation
                  </h3>
                  <p>
                    This type of service allows www.bernicemy.blog to display
                    advertisements for third-party products or services. Ads can
                    be displayed either as advertising links or as banners using
                    various kinds of graphics. Clicks on the icon or banner
                    posted on the Application are tracked by the third-party
                    services listed below, and are shared with
                    www.bernicemy.blog. For details of which data are collected,
                    please refer to the privacy policy of each service.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11437553">
                    Awin (AWIN AG)
                  </h4>
                  <p>
                    Awin is a commercial affiliation service provided by AWIN
                    AG.
                  </p>
                  <p>Personal Data processed: Trackers; Usage Data.</p>
                  <p>
                    Place of processing: Germany –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-13312060">
                    Displaying content from external platforms
                  </h3>
                  <p>
                    This type of service allows you to view content hosted on
                    external platforms directly from the pages of
                    www.bernicemy.blog and interact with them. Such services are
                    often referred to as widgets, which are small elements
                    placed on a website or app. They provide specific
                    information or perform a particular function and often allow
                    for user interaction. This type of service might still
                    collect web traffic data for the pages where the service is
                    installed, even when Users do not use it.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11437548">
                    Google Fonts (Google LLC)
                  </h4>
                  <p>
                    Google Fonts is a typeface visualization service provided by
                    Google LLC that allows www.bernicemy.blog to incorporate
                    content of this kind on its pages.
                  </p>
                  <p>Personal Data processed: Trackers; Usage Data.</p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-12998825">
                    Handling payments
                  </h3>
                  <p>
                    Unless otherwise specified, www.bernicemy.blog processes any
                    payments by credit card, bank transfer or other means via
                    external payment service providers. In general and unless
                    where otherwise stated, Users are requested to provide their
                    payment details and personal information directly to such
                    payment service providers. Www.bernicemy.blog isn't involved
                    in the collection and processing of such information:
                    instead, it will only receive a notification by the relevant
                    payment service provider as to whether payment has been
                    successfully completed.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11132979">
                    PayPal (PayPal Inc.)
                  </h4>
                  <p>
                    PayPal is a payment service provided by PayPal Inc., which
                    allows Users to make online payments.
                  </p>
                  <p>
                    Personal Data processed: email address; payment info;
                    Trackers; Usage Data.
                  </p>
                  <p>
                    Place of processing: See the PayPal privacy policy –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-13312067">
                    Heat mapping and session recording
                  </h3>
                  <p>
                    Heat mapping services are used to display the areas of
                    www.bernicemy.blog that Users interact with most frequently.
                    This shows where the points of interest are. These services
                    make it possible to monitor and analyze web traffic and keep
                    track of User behavior. Some of these services may record
                    sessions and make them available for later visual playback.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11437555">
                    Microsoft Clarity (Microsoft Corporation)
                  </h4>
                  <p>
                    Microsoft Clarity is a session recording and heat mapping
                    service provided by Microsoft Corporation. Microsoft
                    processes or receives Personal Data via Microsoft Clarity,
                    which in turn may be used for any purpose in accordance with
                    the Microsoft Privacy Statement, including improving and
                    providing Microsoft Advertising.
                  </p>
                  <p>
                    Personal Data processed: clicks; interaction events; mouse
                    movements; session duration; Trackers.
                  </p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11437562">
                    Hotjar Heat Maps and Recordings (Hotjar Ltd.)
                  </h4>
                  <p>
                    Hotjar is a session recording and heat mapping service
                    provided by Hotjar Ltd. Hotjar honors generic „Do Not Track”
                    headers. This means the browser can tell its script not to
                    collect any of the User's data. This is a setting that is
                    available in all major browsers. Find Hotjar’s{" "}
                    <Link onClick={toTop} to="/">
                      opt-out information here
                    </Link>
                    .
                  </p>
                  <p>
                    Personal Data processed: Trackers; Usage Data; various types
                    of Data as specified in the privacy policy of the service.
                  </p>
                  <p>
                    Place of processing: Malta –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>{" "}
                    –{" "}
                    <Link onClick={toTop} to="/">
                      Opt Out
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-13312062">
                    Hosting and backend infrastructure
                  </h3>
                  <p>
                    This type of service has the purpose of hosting Data and
                    files that enable www.bernicemy.blog to run and be
                    distributed as well as to provide a ready-made
                    infrastructure to run specific features or parts of
                    www.bernicemy.blog.
                  </p>
                  <p>
                    Some services among those listed below, if any, may work
                    through geographically distributed servers, making it
                    difficult to determine the actual location where the
                    Personal Data are stored.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11437550">
                    Amazon S3 (Amazon Web Services, Inc.)
                  </h4>
                  <p>
                    Amazon S3 is a cloud storage service provided by Amazon Web
                    Services, Inc.
                  </p>
                  <p>Personal Data processed: Usage Data.</p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-12998822">
                    Managing contacts and sending messages
                  </h3>
                  <p>
                    This type of service makes it possible to manage a database
                    of email contacts, phone contacts or any other contact
                    information to communicate with the User. These services may
                    also collect data concerning the date and time when the
                    message was viewed by the User, as well as when the User
                    interacted with it, such as by clicking on links included in
                    the message.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11132976">
                    Klaviyo (Klaviyo Inc.)
                  </h4>
                  <p>
                    Klaviyo is an email address management and message sending
                    service provided by Klaviyo Inc.
                  </p>
                  <p>
                    To take advantage of the service provided by Klaviyo, the
                    Owner typically shares information about (purchasing) Users,
                    such as for example contact details and shopping histories.
                    Check the indication at “Personal Data processed“ below for
                    an explanation of the extent of the sharing.
                  </p>
                  <p>
                    Personal Data processed: email address; purchase history;
                    Trackers; Usage Data.
                  </p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>{" "}
                    –{" "}
                    <Link onClick={toTop} to="/">
                      Opt out
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11437551">
                    Attentive (Attentive Mobile, Inc.)
                  </h4>
                  <p>
                    Attentive is a message-sending service provided by Attentive
                    Mobile, Inc. Attentive uses the Attentive tag as a Tracker
                    to recognize and track User behavior as well as to manage
                    any User-entered data such as email or telephone numbers.
                  </p>
                  <p>
                    Personal Data processed: email address; phone number;
                    Trackers; Usage Data.
                  </p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-12998826">
                    Platform services and hosting
                  </h3>
                  <p>
                    These services have the purpose of hosting and running key
                    components of www.bernicemy.blog, therefore allowing the
                    provision of www.bernicemy.blog from within a unified
                    platform. Such platforms provide a wide range of tools to
                    the Owner – e.g. analytics, user registration, commenting,
                    database management, e-commerce, payment processing – that
                    imply the collection and handling of Personal Data. Some of
                    these services work through geographically distributed
                    servers, making it difficult to determine the actual
                    location where the Personal Data are stored.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11132980">
                    Shopify (Shopify Inc.)
                  </h4>
                  <p>
                    Shopify is a platform provided by Shopify Inc. that allows
                    the Owner to build, run and host an e-commerce website. This
                    service may place Trackers on the User’s device. For the
                    most up-to-date and comprehensive information, refer to the
                    service’s{" "}
                    <Link onClick={toTop} to="/">
                      official documentation
                    </Link>
                    .
                  </p>
                  <p>
                    Personal Data processed: device information; Trackers; Usage
                    Data.
                  </p>
                  <p>
                    Place of processing: Canada –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-12998828">
                    Remarketing and behavioral targeting
                  </h3>
                  <p>
                    This type of service allows www.bernicemy.blog and its
                    partners to inform, optimize and serve advertising based on
                    past use of www.bernicemy.blog by the User. This activity is
                    facilitated by tracking Usage Data and by using Trackers to
                    collect information which is then transferred to the
                    partners that manage the remarketing and behavioral
                    targeting activity. Some services offer a remarketing option
                    based on email address lists. Services of this kind usually
                    allow Users to opt out of such tracking. Users may learn how
                    to opt out of interest-based advertising more generally by
                    visiting the relevant opt-out section in this document.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11132982">
                    TikTok Remarketing ( TikTok Information Technologies UK
                    Limited )
                  </h4>
                  <p>
                    TikTok Remarketing is a remarketing and behavioral targeting
                    service provided by TikTok Information Technologies UK
                    Limited that connects the activity of www.bernicemy.blog
                    with the TikTok advertising network.
                  </p>
                  <p>Personal Data processed: Trackers.</p>
                  <p>
                    Place of processing: United Kingdom –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-13312061">
                    Spam and bots protection
                  </h3>
                  <p>
                    This type of service analyzes the traffic of
                    www.bernicemy.blog, potentially containing Users' Personal
                    Data, with the purpose of filtering it from unwanted parts
                    of traffic, messages and content that are recognized as spam
                    or protecting it from malicious bots activities.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11437549">
                    Google reCAPTCHA (Google LLC)
                  </h4>
                  <p>
                    Google reCAPTCHA is a SPAM protection service provided by
                    Google LLC. The use of reCAPTCHA is subject to the Google{" "}
                    <Link onClick={toTop} to="/">
                      privacy policy
                    </Link>{" "}
                    and{" "}
                    <Link onClick={toTop} to="/terms">
                      terms of use
                    </Link>
                    .
                  </p>
                  <p>
                    In order to understand Google's use of Data, consult their{" "}
                    <Link onClick={toTop} to="/">
                      partner policy
                    </Link>{" "}
                    and their{" "}
                    <Link onClick={toTop} to="/">
                      Business Data page
                    </Link>
                    .
                  </p>
                  <p>
                    Personal Data processed: answers to questions; clicks;
                    keypress events; motion sensor events; mouse movements;
                    scroll position; touch events; Trackers; Usage Data.
                  </p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-12998821">
                    Tag Management
                  </h3>
                  <p>
                    This type of service helps the Owner to manage the tags or
                    scripts needed on www.bernicemy.blog in a centralized
                    fashion. This results in the Users' Data flowing through
                    these services, potentially resulting in the retention of
                    this Data.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11132975">
                    Google Tag Manager (Google LLC)
                  </h4>
                  <p>
                    Google Tag Manager is a tag management service provided by
                    Google LLC.
                  </p>
                  <p>
                    In order to understand Google's use of Data, consult their{" "}
                    <Link onClick={toTop} to="/">
                      partner policy
                    </Link>{" "}
                    and their{" "}
                    <Link onClick={toTop} to="/">
                      Business Data page
                    </Link>
                    .
                  </p>
                  <p>Personal Data processed: Trackers; Usage Data.</p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h3 className="iub-purpose iub-purpose-13312064">
                    Traffic optimization and distribution
                  </h3>
                  <p>
                    This type of service allows www.bernicemy.blog to distribute
                    their content using servers located across different
                    countries and to optimize their performance. Which Personal
                    Data are processed depends on the characteristics and the
                    way these services are implemented. Their function is to
                    filter communications between www.bernicemy.blog and the
                    User's browser. Considering the widespread distribution of
                    this system, it is difficult to determine the locations to
                    which the contents that may contain Personal Information of
                    the User are transferred.
                  </p>
                  {/* Service start */}
                  <h4 className="iub-service iub-service-11437552">
                    Cloudflare (Cloudflare, Inc.)
                  </h4>
                  <p>
                    Cloudflare is a traffic optimization and distribution
                    service provided by Cloudflare Inc. The way Cloudflare is
                    integrated means that it filters all the traffic through
                    www.bernicemy.blog, i.e., communication between
                    www.bernicemy.blog and the User's browser, while also
                    allowing analytical data from www.bernicemy.blog to be
                    collected.
                  </p>
                  <p>
                    Personal Data processed: Trackers; various types of Data as
                    specified in the privacy policy of the service.
                  </p>
                  <p>
                    Place of processing: United States –{" "}
                    <Link onClick={toTop} to="/">
                      Privacy Policy
                    </Link>
                    .{" "}
                  </p>
                  {/* Service end */}
                  <h2 id="opt_out">
                    Information on opting out of interest-based advertising
                  </h2>
                  <p>
                    In addition to any opt-out feature provided by any of the
                    services listed in this document, Users may learn more on
                    how to generally opt out of interest-based advertising
                    within the dedicated section of the Cookie Policy.
                  </p>
                  <div data-locale="en" />
                  <div className="one_line_col">
                    <h2 id="cookie_policy">Cookie Policy</h2>
                    <p>
                      Www.bernicemy.blog uses Trackers. To learn more, Users may
                      consult the{" "}
                      <Link
                        onClick={toTop}
                        to="/"
                        className="show_comp_link iframe-preserve an-preserve"
                      >
                        Cookie Policy
                      </Link>
                      .
                    </p>
                  </div>
                  <h2 id="cookie_policy_further_information">
                    Further Information for Users in the European Union{" "}
                  </h2>
                  <p id="gdpr_info">
                    This section applies to all Users in the European Union,
                    according to the General Data Protection Regulation (the
                    “GDPR”), and, for such Users, supersedes any other possibly
                    divergent or conflicting information contained in the
                    privacy policy. Further details regarding the categories of
                    Data processed, the purposes of processing, the categories
                    of recipients of the Personal Data, if any, and further
                    information about Personal Data can be found in{" "}
                    <strong>
                      the section titled “Detailed information on the processing
                      of Personal Data” within this document
                    </strong>
                    .
                  </p>
                  <h3 className="iub-subheading iub-subheading-legal-basis-of-processing">
                    Legal basis of processing
                  </h3>
                  <p>
                    The Owner may process Personal Data relating to Users if one
                    of the following applies:
                  </p>
                  <ul>
                    <li>
                      Users have given their consent for one or more specific
                      purposes.
                    </li>
                    <li>
                      provision of Data is necessary for the performance of an
                      agreement with the User and/or for any pre-contractual
                      obligations thereof;
                    </li>
                    <li>
                      processing is necessary for compliance with a legal
                      obligation to which the Owner is subject;
                    </li>
                    <li>
                      processing is related to a task that is carried out in the
                      public interest or in the exercise of official authority
                      vested in the Owner;
                    </li>
                    <li>
                      processing is necessary for the purposes of the legitimate
                      interests pursued by the Owner or by a third party.
                    </li>
                  </ul>
                  <p>
                    In any case, the Owner will gladly help to clarify the
                    specific legal basis that applies to the processing, and in
                    particular whether the provision of Personal Data is a
                    statutory or contractual requirement, or a requirement
                    necessary to enter into a contract.{" "}
                  </p>
                  <h3 className="iub-subheading iub-subheading-legal-time">
                    Further information about retention time
                  </h3>
                  <p>
                    Unless specified otherwise in this document, Personal Data
                    shall be processed and stored for as long as required by the
                    purpose they have been collected for and may be retained for
                    longer due to applicable legal obligation or based on the
                    Users’ consent.
                  </p>
                  <p>Therefore:</p>
                  <ul>
                    <li>
                      Personal Data collected for purposes related to the
                      performance of a contract between the Owner and the User
                      shall be retained until such contract has been fully
                      performed.
                    </li>
                    <li>
                      Personal Data collected for the purposes of the Owner’s
                      legitimate interests shall be retained as long as needed
                      to fulfill such purposes. Users may find specific
                      information regarding the legitimate interests pursued by
                      the Owner within the relevant sections of this document or
                      by contacting the Owner.
                    </li>
                  </ul>
                  <p>
                    The Owner may be allowed to retain Personal Data for a
                    longer period whenever the User has given consent to such
                    processing, as long as such consent is not withdrawn.
                    Furthermore, the Owner may be obliged to retain Personal
                    Data for a longer period whenever required to fulfil a legal
                    obligation or upon order of an authority.
                    <br />
                    <br />
                    Once the retention period expires, Personal Data shall be
                    deleted. Therefore, the right of access, the right to
                    erasure, the right to rectification and the right to data
                    portability cannot be enforced after expiration of the
                    retention period.
                  </p>
                  <h3 id="rights_subjects">
                    The rights of Users based on the General Data Protection
                    Regulation (GDPR)
                  </h3>
                  <p>
                    Users may exercise certain rights regarding their Data
                    processed by the Owner.
                  </p>
                  <p>
                    In particular, Users have the right to do the following, to
                    the extent permitted by law:
                  </p>
                  <ul>
                    <li>
                      <strong>Withdraw their consent at any time.</strong> Users
                      have the right to withdraw consent where they have
                      previously given their consent to the processing of their
                      Personal Data.
                    </li>
                    <li>
                      <strong>Object to processing of their Data.</strong> Users
                      have the right to object to the processing of their Data
                      if the processing is carried out on a legal basis other
                      than consent.
                    </li>
                    <li>
                      <strong>Access their Data.</strong> Users have the right
                      to learn if Data is being processed by the Owner, obtain
                      disclosure regarding certain aspects of the processing and
                      obtain a copy of the Data undergoing processing.
                    </li>
                    <li>
                      <strong>Verify and seek rectification.</strong> Users have
                      the right to verify the accuracy of their Data and ask for
                      it to be updated or corrected.
                    </li>
                    <li>
                      <strong>Restrict the processing of their Data.</strong>{" "}
                      Users have the right to restrict the processing of their
                      Data. In this case, the Owner will not process their Data
                      for any purpose other than storing it.
                    </li>
                    <li>
                      <strong>
                        Have their Personal Data deleted or otherwise removed.
                      </strong>{" "}
                      Users have the right to obtain the erasure of their Data
                      from the Owner.
                    </li>
                    <li>
                      <strong>
                        Receive their Data and have it transferred to another
                        controller.
                      </strong>{" "}
                      Users have the right to receive their Data in a
                      structured, commonly used and machine readable format and,
                      if technically feasible, to have it transmitted to another
                      controller without any hindrance.
                    </li>
                    <li>
                      <strong>Lodge a complaint.</strong> Users have the right
                      to bring a claim before their competent data protection
                      authority.
                    </li>
                  </ul>
                  <p>
                    Users are also entitled to learn about the legal basis for
                    Data transfers abroad including to any international
                    organization governed by public international law or set up
                    by two or more countries, such as the UN, and about the
                    security measures taken by the Owner to safeguard their
                    Data.
                  </p>
                  <h4 className="iub-subheading iub-subheading-legal-right-to-object">
                    Details about the right to object to processing
                  </h4>
                  <p>
                    <strong>
                      Where Personal Data is processed for a public interest, in
                      the exercise of an official authority vested in the Owner
                      or for the purposes of the legitimate interests pursued by
                      the Owner, Users may object to such processing by
                      providing a ground related to their particular situation
                      to justify the objection.
                    </strong>
                  </p>
                  <p>
                    <strong>
                      Users must know that, however, should their Personal Data
                      be processed for direct marketing purposes, they can
                      object to that processing at any time, free of charge and
                      without providing any justification. Where the User
                      objects to processing for direct marketing purposes, the
                      Personal Data will no longer be processed for such
                      purposes. To learn whether the Owner is processing
                      Personal Data for direct marketing purposes, Users may
                      refer to the relevant sections of this document.{" "}
                    </strong>
                  </p>
                  <h4 className="iub-subheading iub-subheading-legal-how-to-exercise">
                    How to exercise these rights
                  </h4>
                  <p>
                    Any requests to exercise User rights can be directed to the
                    Owner through the{" "}
                    <Link onClick={toTop} to="/">
                      dedicated online form
                    </Link>{" "}
                    or the contact details provided in this document. Such
                    requests are free of charge and will be answered by the
                    Owner as early as possible and always within one month,
                    providing Users with the information required by law. Any
                    rectification or erasure of Personal Data or restriction of
                    processing will be communicated by the Owner to each
                    recipient, if any, to whom the Personal Data has been
                    disclosed unless this proves impossible or involves
                    disproportionate effort. At the Users’ request, the Owner
                    will inform them about those recipients.
                  </p>
                  <div className="one_line_col"></div>
                  <h2 id="further_data_processing_info">
                    Additional information about Data collection and processing
                  </h2>
                  <h3 className="iub-subheading iub-subheading-legal-protection">
                    Legal action
                  </h3>
                  <p>
                    The User's Personal Data may be used for legal purposes by
                    the Owner in Court or in the stages leading to possible
                    legal action arising from improper use of www.bernicemy.blog
                    or the related Services.
                    <br />
                    The User declares to be aware that the Owner may be required
                    to reveal personal data upon request of public authorities.
                  </p>
                  <h3 className="iub-subheading iub-subheading-legal-specific-info">
                    Additional information about User's Personal Data
                  </h3>
                  <p>
                    In addition to the information contained in this privacy
                    policy, www.bernicemy.blog may provide the User with
                    additional and contextual information concerning particular
                    Services or the collection and processing of Personal Data
                    upon request.
                  </p>
                  <h3 className="iub-subheading iub-subheading-legal-maintenance">
                    System logs and maintenance
                  </h3>
                  <p>
                    For operation and maintenance purposes, www.bernicemy.blog
                    and any third-party services may collect files that record
                    interaction with www.bernicemy.blog (System logs) or use
                    other Personal Data (such as the IP Address) for this
                    purpose.
                  </p>
                  <h3 className="iub-subheading iub-subheading-legal-information-not-contained">
                    Information not contained in this policy
                  </h3>
                  <p>
                    More details concerning the collection or processing of
                    Personal Data may be requested from the Owner at any time.
                    Please see the contact information at the beginning of this
                    document.
                  </p>
                  <h3>Changes to this privacy policy</h3>
                  <p>
                    The Owner reserves the right to make changes to this privacy
                    policy at any time by notifying its Users on this page and
                    possibly within www.bernicemy.blog and/or - as far as
                    technically and legally feasible - sending a notice to Users
                    via any contact information available to the Owner. It is
                    strongly recommended to check this page often, referring to
                    the date of the last modification listed at the bottom.{" "}
                    <br />
                    <br />
                    Should the changes affect processing activities performed on
                    the basis of the User’s consent, the Owner shall collect new
                    consent from the User, where required.
                  </p>
                  <h3 id="definitions_and_legal_references">
                    Definitions and legal references
                  </h3>
                  <h4>Personal Data (or Data)</h4>
                  <p>
                    Any information that directly, indirectly, or in connection
                    with other information — including a personal identification
                    number — allows for the identification or identifiability of
                    a natural person.
                  </p>
                  <h4>Usage Data</h4>
                  <p>
                    Information collected automatically through
                    www.bernicemy.blog (or third-party services employed in
                    www.bernicemy.blog), which can include: the IP addresses or
                    domain names of the computers utilized by the Users who use
                    www.bernicemy.blog, the URI addresses (Uniform Resource
                    Identifier), the time of the request, the method utilized to
                    submit the request to the server, the size of the file
                    received in response, the numerical code indicating the
                    status of the server's answer (successful outcome, error,
                    etc.), the country of origin, the features of the browser
                    and the operating system utilized by the User, the various
                    time details per visit (e.g., the time spent on each page
                    within the Application) and the details about the path
                    followed within the Application with special reference to
                    the sequence of pages visited, and other parameters about
                    the device operating system and/or the User's IT
                    environment.
                  </p>
                  <h4>User</h4>
                  <p>
                    The individual using www.bernicemy.blog who, unless
                    otherwise specified, coincides with the Data Subject.
                  </p>
                  <h4>Data Subject</h4>
                  <p>The natural person to whom the Personal Data refers.</p>
                  <h4>Data Processor (or Processor)</h4>
                  <p>
                    The natural or legal person, public authority, agency or
                    other body which processes Personal Data on behalf of the
                    Controller, as described in this privacy policy.
                  </p>
                  <h4>Data Controller (or Owner)</h4>
                  <p>
                    The natural or legal person, public authority, agency or
                    other body which, alone or jointly with others, determines
                    the purposes and means of the processing of Personal Data,
                    including the security measures concerning the operation and
                    use of www.bernicemy.blog. The Data Controller, unless
                    otherwise specified, is the Owner of www.bernicemy.blog.
                  </p>
                  <h4>www.bernicemy.blog (or this Application)</h4>
                  <p>
                    The means by which the Personal Data of the User is
                    collected and processed.
                  </p>
                  <h4>Service</h4>
                  <p>
                    The service provided by www.bernicemy.blog as described in
                    the relative terms (if available) and on this
                    site/application.
                  </p>
                  <h4>European Union (or EU)</h4>
                  <p>
                    Unless otherwise specified, all references made within this
                    document to the European Union include all current member
                    states to the European Union and the European Economic Area.
                  </p>
                  <h4>Cookie</h4>
                  <p>
                    Cookies are Trackers consisting of small sets of data stored
                    in the User's browser.
                  </p>
                  <h4>Tracker</h4>
                  <p>
                    Tracker indicates any technology - e.g Cookies, unique
                    identifiers, web beacons, embedded scripts, e-tags and
                    fingerprinting - that enables the tracking of Users, for
                    example by accessing or storing information on the User’s
                    device.
                  </p>
                  <h4>Legal information</h4>
                  <p>
                    This privacy policy relates solely to www.bernicemy.blog, if
                    not stated otherwise within this document.
                  </p>
                  <p>Latest update: January 07, 2025</p>
                  <p></p>
                  <p>
                    <Link
                      onClick={toTop}
                      className="link-underline"
                      to="/"
                      title="iubenda - Privacy Policy generator"
                    >
                      iubenda
                    </Link>{" "}
                    hosts this content and only collects{" "}
                    <Link onClick={toTop} className="link-underline" to="/">
                      the Personal Data strictly necessary
                    </Link>{" "}
                    for it to be provided.
                  </p>
                </div>
                {/* /iubenda_legal_document */}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </body>
  );
}

export default Privacy;
